var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-77 79 100 100",
    xmlSpace: "preserve",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-36.1,171.1h2.2v-9.3h-2.2V171.1z M-22.5,170.4l1.9-1.2l-5.5-8.3l-1.9,1.2L-22.5,170.4z M-14.9,161.8l1.1-2l-7.7-4.2 l-1.1,2L-14.9,161.8z M-11.1,154.3v18.5h-27.6v-18.5H-77v6.2h32.5V179h39.3v-18.5h27.8v-6.2H-11.1z M-37.6,91.7 c3.4,0.4,6.6-2,7.1-5.6c0.4-3.4-2-6.6-5.6-7.1c-3.4-0.4-6.6,2-7.1,5.6C-43.6,88.2-41.1,91.4-37.6,91.7 M-46.4,93.1 c1.2-0.9,2.8-1.3,4.5-1.2c2.1,0.3,3.9,1.7,4.9,3.3l5.9,12.9l8.4,6.4c0.7,0.6,1.2,1.6,1.1,2.5c-0.1,1.6-1.6,2.7-3.2,2.4 c-0.4,0-0.9-0.2-1.3-0.5l-9.1-6.7c-0.2-0.3-0.5-0.6-0.7-0.9l-2.2-4.8l-3.3,12.5l10.8,13.8c0.2,0.4,0.4,0.9,0.5,1.4l2.4,16.2 c0,0.4,0,0.6,0,0.9c-0.3,2.4-2.4,4-4.8,3.8c-1.9-0.3-3.3-1.7-3.7-3.5l-2.3-15.1l-8.8-10.5l-2.5,9.7c-0.1,0.4-0.8,1.4-1,1.7 l-9.3,14.5c-0.9,1.3-2.4,2.1-4.1,1.9c-2.4-0.3-4.1-2.4-3.8-4.8c0.1-0.7,0.4-1.3,0.7-1.9l8.7-13.3l7.9-29.9l-4.6,3.4l-2.8,10.6 c-0.3,1.3-1.7,2.4-3.1,2.3c-1.6-0.1-2.7-1.6-2.5-3.2c0-0.1,0-0.2,0.1-0.4l3.2-12.4c0.2-0.6,0.5-0.9,0.9-1.3L-46.4,93.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.24232f69ee95efcd659e85cbd267908d.svg";
export { ForwardRef as ReactComponent };